/* Planner Studio — candlestick canvas + scroll reveal. ~2KB, no deps. */
(function(){
  var reduce=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function reveal(){
    var els=document.querySelectorAll('.ps-reveal:not(.is-in)');
    if(reduce||!('IntersectionObserver' in window)){els.forEach(function(e){e.classList.add('is-in')});return}
    var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('is-in');io.unobserve(e.target)}})},{threshold:.15});
    els.forEach(function(e){io.observe(e)});
  }
  function candles(c){
    var ctx=c.getContext('2d'),dpr=Math.min(window.devicePixelRatio||1,2),W,H,bars=[],off=0,step=26,raf,vis=true;
    function seed(n){var p=.6;bars=[];for(var i=0;i<n;i++){var o=p,cl=o+(Math.random()-.52)*.06;bars.push([o,cl,Math.min(o,cl)-Math.random()*.03,Math.max(o,cl)+Math.random()*.03]);p=Math.max(.25,Math.min(.85,cl))}}
    function size(){W=c.clientWidth;H=c.clientHeight;c.width=W*dpr;c.height=H*dpr;ctx.setTransform(dpr,0,0,dpr,0,0);seed(Math.ceil(W/step)+4);draw()}
    function draw(){
      ctx.clearRect(0,0,W,H);ctx.strokeStyle='rgba(40,56,92,.35)';ctx.lineWidth=1;
      for(var x=0;x<W;x+=80){ctx.beginPath();ctx.moveTo(x+.5,0);ctx.lineTo(x+.5,H);ctx.stroke()}
      for(var y=0;y<H;y+=80){ctx.beginPath();ctx.moveTo(0,y+.5);ctx.lineTo(W,y+.5);ctx.stroke()}
      for(var i=0;i<bars.length;i++){var b=bars[i],x=i*step-off,up=b[1]<b[0];
        ctx.fillStyle=ctx.strokeStyle=up?'rgba(212,175,92,.55)':'rgba(90,110,150,.45)';
        ctx.beginPath();ctx.moveTo(x+6,b[2]*H);ctx.lineTo(x+6,b[3]*H);ctx.stroke();
        ctx.fillRect(x,Math.min(b[0],b[1])*H,12,Math.max(2,Math.abs(b[1]-b[0])*H))}
    }
    function tick(){off+=.25;if(off>=step){off=0;bars.shift();var l=bars[bars.length-1][1],cl=l+(Math.random()-.5)*.06;cl=Math.max(.25,Math.min(.85,cl));bars.push([l,cl,Math.min(l,cl)-Math.random()*.03,Math.max(l,cl)+Math.random()*.03])}draw();if(vis)raf=requestAnimationFrame(tick)}
    size();window.addEventListener('resize',size);
    if(!reduce){new IntersectionObserver(function(e){vis=e[0].isIntersecting;cancelAnimationFrame(raf);if(vis)raf=requestAnimationFrame(tick)}).observe(c)}
  }
  function init(){document.querySelectorAll('canvas[data-ps-candles]').forEach(function(c){if(!c._ps){c._ps=1;candles(c)}});reveal()}
  document.readyState==='loading'?document.addEventListener('DOMContentLoaded',init):init();
  document.addEventListener('shopify:section:load',init);
})();
